// Packages
import { configureStore, combineReducers, CaseReducer } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
// Redux
import authSlice from './auth/authReducer';
import userSlice from './user/userReducer';
import groupSlice from './group/groupReducer';
import rateSlice from './rate/rateReducer';
import docSlice from './doc/docReducer';
import leaveSlice from './leave/leaveReducer';
import perfLogsSlice from './perfLogs/perfLogsReducer';
import employeeSlice from './employee/employeeReducer';
import companiesSlice from './companies/companiesReducer';
import contactsSlice from './contacts/contactsReducer';
import locationsSlice from './locations/locationsReducer';
import locationsDocsSlice from './locationsDocs/locationsDocsReducer';
import jobsSlice from './jobs/jobsReducer';
import jobRatesSlice from './jobRates/jobRatesReducer';
import jobLogsSlice from './jobLogs/jobLogsReducer';
import jobGroupsSlice from './jobGroups/jobGroupsReducer';
import jobExpensesSlice from './jobExpenses/jobExpensesReducer';
import todoSlice from './todo/todoReducer';
import scheduleSlice from './schedule/scheduleReducer';
import checkpointsSlice from './checkpoints/checkpointsReducer';
import incidentTypeSlice from './incidentTypes/incidentTypesReducer';
import parkingIssueTypesSlice from './parkingIssueTypes/parkingIssueTypesReducer';
import incidentsSlice from './incidents/incidentReducer';
import parkingIssuesSlice from './parkingIssues/parkingIssuesReducer';
import scansSlice from './scans/scansReducer';
import calendarSlice from './calendar/calendarReducer';
import formsSlice from './form/formReducer';
import paymentsSlice from './payments/paymentsReducer';
import payrollPeriodsSlice from './payrollPeriods/payrollPeriodsReducer';
import holidaysSlice from './holidays/HolidayReducer';
import equipmentSlice from './equipment/equipmentReducer';
import equipmentLogsSlice from './equipmentLogs/equipmentLogsReducer';
import equipmentExpensesSlice from './equipmentExpenses/equipmentExpensesReducer';
import invoiceSettingsSlice from './invoiceSettings/invoiceSettingsReducer';
import recurringInvoiceSlice from './recurringInvoices/recurringInvoiceReducer';
import invoiceSlice from './invoices/invoicesReducer';
import TimegoHoursSlice from './integration/integrationReducer';
// import TimegoHoursDifferenceSlice from './integration/integrationReducer';
// import synclogsSlice from './integration/integrationReducer';
import unbilledHoursSlice from './unbilledHours/unbilledHoursReducer';
import actionLogsSlice from './actionLogs/ActionLogsReducer';
import navSlice from './nav/navReducer';
import implementationPlansSlice from './ImplementationPlans/implementationPlansReducer';
import invoiceAgingSlice from './invoiceAging/invoiceAgingReducer';
import locationsRatingsSlice from './locationsRating/locationsRatingsReducer';
import timeOutsideGeofenceReportSlice from './outsideGeofenceReport/outsideGeofenceReportReducer';
import payrollAdjustmentsSlice from './payrollAdjustment/payrollAdjustmentReducer';
import contactLogsSlice from './contactLogs/contactLogsReducer';
import laborBurdenLabelsSlice from './laborBurdenLabels/laborBurdenLabelsReducer';
import laborBurdenCalculationSlice from './laborBurdenCalculations/laborBurdenCalculationsReducer';
import missedCheckinsReportSlice from './missedCheckinsReport/missedCheckinsReportReducer';
import candidatesSlice from './candidates/candidatesReducer';
import clientLoginsSlice from './clientLogins/clientLoginsReducer';
import tardyReportSlice from './tardyReport/tardyReportReducer';
import statusListsSlice from './statusLists/statusListsReducer';

const rootReducer = combineReducers({
  // AUTH REDUCER
  [authSlice.name]: authSlice.reducer,
  // USER REDUCER
  [userSlice.name]: userSlice.reducer,
  // EMPLOYEE REDUCER
  [employeeSlice.name]: employeeSlice.reducer,
  [groupSlice.name]: groupSlice.reducer,
  [rateSlice.name]: rateSlice.reducer,
  [leaveSlice.name]: leaveSlice.reducer,
  [perfLogsSlice.name]: perfLogsSlice.reducer,
  [docSlice.name]: docSlice.reducer,
  // COMPANIES REDUCER
  [companiesSlice.name]: companiesSlice.reducer,
  [contactsSlice.name]: contactsSlice.reducer,
  [locationsSlice.name]: locationsSlice.reducer,
  [locationsDocsSlice.name]: locationsDocsSlice.reducer,
  // JOBS REDUCER
  [jobsSlice.name]: jobsSlice.reducer,
  [jobRatesSlice.name]: jobRatesSlice.reducer,
  [jobGroupsSlice.name]: jobGroupsSlice.reducer,
  [jobLogsSlice.name]: jobLogsSlice.reducer,
  [jobExpensesSlice.name]: jobExpensesSlice.reducer,
  // TO-DO REDUCER
  [todoSlice.name]: todoSlice.reducer,
  // SCHEDULE REDUCER
  [scheduleSlice.name]: scheduleSlice.reducer,
  // CHECKPOINTS REDUCER
  [checkpointsSlice.name]: checkpointsSlice.reducer,
  [scansSlice.name]: scansSlice.reducer,
  [incidentTypeSlice.name]: incidentTypeSlice.reducer,
  [parkingIssueTypesSlice.name]: parkingIssueTypesSlice.reducer,
  [incidentsSlice.name]: incidentsSlice.reducer,
  [parkingIssuesSlice.name]: parkingIssuesSlice?.reducer,
  // CALENDAR REDUCER
  [calendarSlice.name]: calendarSlice.reducer,
  // FORMS REDUCER
  [formsSlice.name]: formsSlice.reducer,
  // PAYMENTS REDUCER
  [paymentsSlice.name]: paymentsSlice.reducer,
  // PAYROLL PERIODS REDUCER
  [payrollPeriodsSlice.name]: payrollPeriodsSlice.reducer,
  [payrollAdjustmentsSlice.name]: payrollAdjustmentsSlice.reducer,
  // HOLIDAYS REDUCER
  [holidaysSlice.name]: holidaysSlice.reducer,
  // EQUIPMENT REDUCER
  [equipmentSlice.name]: equipmentSlice.reducer,
  [equipmentLogsSlice.name]: equipmentLogsSlice.reducer,
  [equipmentExpensesSlice.name]: equipmentExpensesSlice.reducer,
  // INVOICES REDUCER
  [invoiceSettingsSlice.name]: invoiceSettingsSlice.reducer,
  [recurringInvoiceSlice.name]: recurringInvoiceSlice.reducer,
  [invoiceSlice.name]: invoiceSlice.reducer,
  [unbilledHoursSlice.name]: unbilledHoursSlice.reducer,
  [invoiceAgingSlice.name]: invoiceAgingSlice.reducer,
  // TIMEGO HOURS REDUCER
  [TimegoHoursSlice.name]: TimegoHoursSlice.reducer,
  // TIMEGO HOURS DIFFERENCE REDUCER
  // [TimegoHoursDifferenceSlice.name]: TimegoHoursSlice.reducer,
  // // SYNC LOGS REDUCER
  // [synclogsSlice.name]: synclogsSlice.reducer,
  // ACTION LOGS REDUCER
  [actionLogsSlice.name]: actionLogsSlice.reducer,
  // NAV LOGS REDUCER
  [navSlice.name]: navSlice.reducer,
  // IMPLEMENTATION PLAN REDUCER
  [implementationPlansSlice.name]: implementationPlansSlice.reducer,
  // REPORTS REDUCER
  [timeOutsideGeofenceReportSlice.name]: timeOutsideGeofenceReportSlice.reducer,
  [locationsRatingsSlice.name]: locationsRatingsSlice.reducer,
  [contactLogsSlice.name]: contactLogsSlice.reducer,
  [laborBurdenLabelsSlice.name]: laborBurdenLabelsSlice.reducer,
  [laborBurdenCalculationSlice.name]: laborBurdenCalculationSlice.reducer,
  [missedCheckinsReportSlice.name]: missedCheckinsReportSlice.reducer,
  [candidatesSlice.name]: candidatesSlice.reducer,
  [clientLoginsSlice.name]: clientLoginsSlice.reducer,
  [tardyReportSlice.name]: tardyReportSlice.reducer,
  // STATUS FILTER OPTIONS REDUCER
  [statusListsSlice.name]: statusListsSlice.reducer,
});

// STORE INIT
export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware(),
});

// ROOT STATE
type RootReducerType = typeof rootReducer;
export type RootState = ReturnType<RootReducerType>;

// USE DISPATCH
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

// USE SELECTOR
type TStoreKeys = keyof RootState;
const getConnectedStore = <K extends TStoreKeys>(key: K) => {
  return () => useSelector((state: RootState) => state[key]);
};
export const useAppSelector = <K extends TStoreKeys>(key: K) => getConnectedStore(key)();

export const STORE_KEYS = {
  AUTH: authSlice.name,
  USER: userSlice.name,
  EMPLOYEE: employeeSlice.name,
  GROUP: groupSlice.name,
  RATE: rateSlice.name,
  LEAVE: leaveSlice.name,
  PERF_LOGS: perfLogsSlice.name,
  DOC: docSlice.name,
  COMPANIES: companiesSlice.name,
  CONTACTS: contactsSlice.name,
  LOCATIONS: locationsSlice.name,
  LOCATIONS_DOCS: locationsDocsSlice.name,
  JOBS: jobsSlice.name,
  JOB_RATES: jobRatesSlice.name,
  JOB_GROUPS: jobGroupsSlice.name,
  JOB_LOGS: jobLogsSlice.name,
  JOB_EXPENSES: jobExpensesSlice.name,
  TODO: todoSlice.name,
  SCHEDULE: scheduleSlice.name,
  CHECKPOINTS: checkpointsSlice.name,
  PARKING_ISSUES: parkingIssuesSlice.name,
  INCIDENTS_TYPES: incidentTypeSlice.name,
  INCIDENTS: incidentsSlice.name,
  PARKING_ISSUES_TYPE: parkingIssueTypesSlice.name,
  SCANS: scansSlice.name,
  CALENDAR: calendarSlice.name,
  FORMS: formsSlice.name,
  PAYMENTS: paymentsSlice.name,
  PAYROLLS: payrollPeriodsSlice.name,
  PAYROLL_ADJUSTMENTS: payrollAdjustmentsSlice?.name,
  HOLIDAYS: holidaysSlice.name,
  EQUIPMENT: equipmentSlice.name,
  EQUIPMENT_LOGS: equipmentLogsSlice.name,
  EQUIPMENT_EXPENSES: equipmentExpensesSlice.name,
  INVOICE_SETTINGS: invoiceSettingsSlice.name,
  RECURRING_INVOICE: recurringInvoiceSlice.name,
  INVOICE: invoiceSlice.name,
  UNBILLED_HOURS: unbilledHoursSlice.name,
  TIMGOHOURS: TimegoHoursSlice.name,
  TIMEGOHOURSDIFFRENCE: TimegoHoursSlice.name,
  SYNCLOGS: TimegoHoursSlice.name,
  ACTION_LOGS: actionLogsSlice.name,
  NAV: navSlice.name,
  IMPLEMENTATION_PLANS: implementationPlansSlice.name,
  INVOICE_AGING: invoiceAgingSlice.name,
  TIME_OUTSIDE_GEOFENCE: timeOutsideGeofenceReportSlice.name,
  LOCATIONS_RATING_MAIN_COMPANY: locationsRatingsSlice.name,
  CONTACT_LOGS: contactLogsSlice.name,
  LABOR_BURDEN_LABELS: laborBurdenLabelsSlice.name,
  LABOR_BURDEN_CALCULATIONS: laborBurdenCalculationSlice.name,
  MISSED_CHECKINS_REPORT: missedCheckinsReportSlice.name,
  CANDIDATES: candidatesSlice.name,
  CLIENT_LOGINS: clientLoginsSlice.name,
  TARDY_REPORT: tardyReportSlice.name,
  STATUS_LISTS: statusListsSlice.name,
};

export type TSliceReducer<
  SliceState,
  ActionCreator extends (...args: any) => any,
> = CaseReducer<SliceState, ReturnType<ActionCreator>>;

export type TActionType = 'pending' | 'fulfilled' | 'rejected';

export default store;
